import { v4 } from 'uuid';
import { STATUS } from '@front-app/constants/state';
import { uploadFile, UploadFileRequest } from '@front-app/services/GroupsApi/GroupFileApi';
import { computed, reactive, Ref } from '@vue/composition-api';

export interface UploadsStore {
	uploads: Ref<UploadState[]>;
	errors: Ref<UploadState[]>;
	upload(req: UploadFileRequest): Promise<void>;
	clear(): void;
}

export interface UploadState {
	id: string;
	status: STATUS;
	fileName: string;
	progress: number;
}

export const getUploadsStore = (): UploadsStore => {
	const state = reactive({
		uploads: [] as string[],
	});
	let uploadStates: Record<string, UploadState> = {};
	const upload = async (req: UploadFileRequest): Promise<void> => {
		const uploadState = reactive({
			id: v4(),
			status: STATUS.LOADING,
			fileName: req.fileName,
			progress: 0,
		});
		const onProgress = (e: ProgressEvent) => {
			uploadState.progress = e.loaded / e.total;
		};
		const promisedUpload = uploadFile(req, onProgress);
		uploadStates[uploadState.id] = uploadState;
		state.uploads.push(uploadState.id);
		try {
			await promisedUpload;
			uploadState.status = STATUS.SUCCESS;
		} catch (e) {
			uploadState.status = STATUS.ERROR;
		}
	};
	const clear = () => {
		uploadStates = {};
		state.uploads = [];
	};

	const allUploads = computed(() => state.uploads.map((id) => uploadStates[id]));
	const uploads = computed(() => allUploads.value
		.filter(({ status }) => status !== STATUS.ERROR));
	const errors = computed(() => allUploads.value
		.filter(({ status }) => status === STATUS.ERROR));

	return {
		uploads,
		errors,
		upload,
		clear,
	};
};
